export default {
        data() {
            return {
                downloading: false,
                downloadingUrl: [],
                local_page_keys: {}
            };
        },

        methods: {
            /**
             * Method to download formated to base64 string image to admin's computer
             * accept as argument string of url-address
             * */
            async downLoadExamplefile(example, downloadFunction) {

                let testUrl = '';
                this.downloading = true;
                this.downloadingUrl.push(example);
                try {
                    await this.$store.dispatch("order/downloadExample", example);
                    testUrl = await this.$store.getters['order/downloadExample'](Math.floor(Math.random() * 1000));
                } catch (e) {
                    alert(this.local_page_keys.alert_link_is_not_valid_It_is_not_possible_to_download_the_file+'\n\n'+example+'\n\n'+e);
                }

                if (testUrl !== '' || Object.keys(testUrl).includes('download_img')) {//if url-address is valid began downloading image
                    await fetch(testUrl.download_img, {
                        method: 'GET'
                    })
                        .then(response => response.blob())
                        .then(blob => {
                            let url = window.URL.createObjectURL(blob);
                            let a = document.createElement('a');
                            a.href = url;
                            let ext = blob.type.split('/')[1];
                            a.download = downloadFunction + '.' + (ext !== 'x-photoshop' ? ext : "psd");
                            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                            a.click();
                            a.remove();  //afterwards we remove the element again
                            this.downloadingUrl.shift();
                            this.downloading = this.downloadingUrl.length !== 0 ;
                        }).catch(e => {
                            this.downloadingUrl.shift();
                            this.downloading = this.downloadingUrl.length !== 0;
                            alert(this.local_page_keys.alert_link_is_not_valid_It_is_not_possible_to_download_the_file);
                        });

                    this.logDownloadFile(downloadFunction);
                } else {
                    this.downloadingUrl.shift();
                    this.downloading = this.downloadingUrl.length !== 0;
                    alert(this.local_page_keys.alert_link_is_not_valid_It_is_not_possible_to_download_the_file);
                }
            },
            async logDownloadFile(filename){
                let params = {
                    'filename': filename,
                    'order_id': this.order_id,
                };
                await  this.$store.dispatch('order/logDownloadFile', params);
            },
        },
        async created() {
            this.local_page_keys = await this.$filtergetLocalisationPages(['order-infoBlock','ru_retoucher_translations']);
        }
};